import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchBrand, updateBrand } from 'actions/Brands';
import Button from 'components/CustomButtons/Button';
import CardBody from 'components/Card/CardBody';
import CardWrapper from 'components/Card/CardWrapper';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { TranslatableObjectKey } from 'hooks/redux/Translatable/useTranslatableLanguages';

import LangFormTextInput from '../LangFormTextInput/LangFormTextInput';
import TermsHeader from '../TermsHeader/TermsHeader';

const TermsAndConditions = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { clientLanguages, selectedBrand } = useSelector(({ Auth }) => Auth);

  const [termsContent, setTermsContent] = useState({});
  const [missingTermsContent, setMissingTermsContent] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const brand = await dispatch(
          fetchBrand(selectedBrand, {
            translations: true,
          })
        );

        setTermsContent(brand.termsContent[TranslatableObjectKey]);
        // eslint-disable-next-line no-empty -- FIXME
      } catch {}
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  return (
    <CardWrapper title={t('brandCfg.termsAndConditions')}>
      <CardBody>
        <TermsHeader text={t('brandCfg.termsAndConditionsContent')} />
        {clientLanguages.map(({ id, isoCode }) => (
          <GridContainer key={id}>
            <GridItem md={6}>
              <LangFormTextInput
                lang={isoCode}
                name="termsContent"
                value={termsContent[isoCode] || ''}
                handleChange={e => {
                  setMissingTermsContent(
                    ({ [isoCode]: _, ...missingTermsContentWithoutIsoCode }) =>
                      missingTermsContentWithoutIsoCode
                  );
                  setTermsContent(prev => ({
                    ...prev,
                    [isoCode]: e.target.value,
                  }));
                }}
                isError={!!missingTermsContent[isoCode]}
                inputSize={12}
                multiline={true}
                rows={4}
                rowsMax={20}
                maxLength={4000}
              />
            </GridItem>
          </GridContainer>
        ))}
        <Button
          onClick={async () => {
            const currentMissingTermsContent = {};

            clientLanguages.forEach(({ isoCode }) => {
              if (!termsContent[isoCode]?.trim()) {
                currentMissingTermsContent[isoCode] = true;
              }
            });

            if (Object.keys(currentMissingTermsContent).length > 0) {
              setMissingTermsContent(currentMissingTermsContent);

              toast.error(t('brandCfg.error.serviceTerms.fillMissingFields'));

              return;
            }

            try {
              await dispatch(
                updateBrand(selectedBrand, {
                  termsContent: {
                    [TranslatableObjectKey]: termsContent,
                  },
                })
              );

              toast.success(t('brandCfg.termsAndConditionsChangesSaved'));
              // eslint-disable-next-line no-empty -- FIXME
            } catch {}
          }}
          color="success"
        >
          {t('common.save')}
        </Button>
      </CardBody>
    </CardWrapper>
  );
};

export default TermsAndConditions;
